import { currentDate } from '@witmetrics/utils/time';

export function getInitialDate(
  date?: Date | string | null,
  defaultToCurrent = false
): string | null {
  if (date) return getDateString(date);
  return defaultToCurrent ? currentDate() : null;
}

export function getDateString(date: Date | string) {
  return date instanceof Date ? date.toISOString() : date;
}
